import Sticker from '../board/Sticker';

export class SelectionMarker {
    constructor(public elementData: Sticker, public htmlElement: HTMLElement) {
    }
}
